<template>
    <div class="position-box currency">
        <div class="head">
            <img class="back" v-if="theme" src="@/assets/theme/icon_back.png" @click="back" alt="">
            <img class="back" v-else src="@/assets/icon_back.png" @click="back" alt="">
            <div class="title">{{$t('langNew4.dk')}}</div>
        </div>
        <div id="currency" class="cotainer">
            <div class="cont">
              <div class="currency-head">
                <div class="text">{{$t('langNew4.kyje')}}</div>
                <div class="money-box">{{kyMoney | toFixed4}} <span class="dw">USDT</span></div>
                <div class="tips">{{$t('langNew4.je')}}</div>
                <div class="input-box">
                  <input class="input-money number" type="text" v-model="amount" @keyup="keyMoney()" :placeholder="$t('langNew4.wxj')">
                  <!-- <div class="btn-money">{{$t('langNew4.zd')}}</div> -->
                </div>
                <div class="tips">{{$t('kxt.sj')}}</div>
                <div class="input-box">
                  <input class="input-money" type="text" v-model="cycleDays">
                  <img class="arrow trigger1" src="@/assets/jiantouxia.png" alt="">
                </div>
                <ul class="currency-info">
                  <li class="currency-li">
                    <div class="t1">{{$t('wydb.rll')}}</div>
                    <div class="t2">{{cycleArrDft.day_rate}}%</div>
                  </li>
                  <li class="currency-li">
                    <div class="t1">{{$t('wydb.dbz')}}</div>
                    <div class="t2">{{lend_now}} USDT</div>
                  </li>
                </ul>
                <div class="currency-tips">{{$t('langNew4.dkts')}}</div>
                <div class="btn-buy buttbg" @click="btnBuy">{{$t('langNew4.ljdk')}}</div>
              </div>
              <div class="records-tips">{{$t('langNew4.dkjl')}}</div>
              <ul class="records-ul">
                <li class="records-li" v-for="(item,index) in list" :key="index">
                  <div class="records-head">
                    <div class="order">{{$t('wydb.hkhth')}} {{item.no}}</div>
                    <div class="status">{{item.status_name}}</div>
                  </div>
                  <div class="times">{{$t('wydb.sqrq')}} {{times2(item.start_time)}}</div>
                  <div class="date-box">
                    <div class="date">{{$t('wydb.zq')}} {{item.cycle_days}}</div>
                    <div class="date go" v-show="item.status == 1" @click="goHk(item.id,item)">{{$t('wydb.qhk')}}</div>
                  </div>
                  <ul class="item-ul">
                    <li class="item-li">
                      <div class="tl">{{$t('wydb.dbsl')}}</div>
                      <div class="tr">{{item.amount}} USDT</div>
                    </li>
                    <li class="item-li">
                      <div class="tl">{{$t('wydb.lx')}}</div>
                      <div class="tr">{{item.interest}} USDT</div>
                    </li>
                    <li class="item-li">
                      <div class="tl">{{$t('wydb.zhke')}}</div>
                      <div class="tr">{{(parseFloat(item.amount) + parseFloat(item.interest)).toFixed(4)}} USDT</div>
                    </li>
                    <!-- <li class="item-li">
                      <div class="tl">滞纳金</div>
                      <div class="tr">10.0000 USDT</div>
                    </li>
                    <li class="item-li">
                      <div class="tl">逾期天数</div>
                      <div class="tr">30天</div>
                    </li> -->
                  </ul>
                </li>
                <!-- <li class="records-li">
                  <div class="records-head">
                    <div class="order">贷款合同号255224</div>
                    <div class="status">未审核</div>
                  </div>
                  <div class="times">贷款申请时间 2022-01-08  10：05：12</div>
                  <div class="date-box">
                    <div class="date">周期 15</div>
                    <div class="date go">去还款</div>
                  </div>
                  <ul class="item-ul">
                    <li class="item-li">
                      <div class="tl">贷币数量</div>
                      <div class="tr">10.0000 USDT</div>
                    </li>
                    <li class="item-li">
                      <div class="tl">利息</div>
                      <div class="tr">0.0000 USDT</div>
                    </li>
                    <li class="item-li">
                      <div class="tl">总还款额</div>
                      <div class="tr">10.0000 USDT</div>
                    </li>
                    <li class="item-li">
                      <div class="tl">滞纳金</div>
                      <div class="tr">10.0000 USDT</div>
                    </li>
                    <li class="item-li">
                      <div class="tl">逾期天数</div>
                      <div class="tr">30天</div>
                    </li>
                  </ul>
                </li> -->
                <!-- 暂无数据 -->
                <div class="null-box" v-show="isNoData">
                  <img class="icon" v-if="!theme" src="@/assets/Null.png" alt="">
                  <img class="icon" v-else src="@/assets/theme/wushuju.png" alt="">
                  <p class="text">{{$t('zwsj.title')}}</p>
                </div>
              </ul>
            </div>
        </div>
    </div>
</template>

<script>
let that = this;
let vm = null;
export default {
  name: 'currency',
  data () {
    return {
      theme: false,
      lend_now: '',
      lend_history: '',
      lend_count: '',
      amount: '',
      cycleArrDft: {},
      cycleArr: [],
      dayArr: [],
      cycleDays: '',
      photo_fwxx: '',
      photo_srzm: '',
      photo_yhmx: '',
      photo_zjz: '',
      isHouse: 0,
      isMoney: 0,
      isBank: 0,
      isCert: 0,
      list: [],
      kyMoney: '',
      page: 1,
      isGoTOP: false,
      curDataLength: 10,
      isNoData: false,
      count: 1,
      lang: 'en'
    }
  },
  created(){
    vm = this;
    this.theme = JSON.parse(localStorage.getItem('theme'));
    this.lang = localStorage.getItem('language') || 'en';
  },
  mounted() {
    this.getAsset();
    this.getLendMy();
    this.getLendList();
    this.getMylist();
  },
  methods: {
    back(){
      this.$router.go(-1);
    },
    getAsset(){
        this.$ajax.get('/web/getAsset2',{}).then((res) => {
          if(res.data.code == 0){
            let resData = res.data.data;
            this.money = (Number(resData.totalMoney)).toFixed(4);
            this.kyMoney = resData.list.filter((item) =>{
                return item.currency == 'USDT';
            })[0].positions;

          }else{
            this.$router.push('/login');
          }
      }).catch(function(err){
          console.log(err)
      })
    },
    btnBuy(){
      if(!this.amount || this.amount <= 0){
        this.$toast.center(this.$t('wydb.qsrje'));
        return;
      }
      if(this.count == 1){
          this.count = 0;
      }else{
          return false;
      }
      this.$router.push('/upload?id=' + this.cycleArrDft.id + "&amount=" + this.amount)
    },
    getLendMy(){//贷币信息
      let that = this;
      this.$ajax.get('/web/lendMy',{}).then((res) => {
          let resData = res.data.data;
          if(res.data.code == 1000){
            // this.$toast.center(res.data.message);
            setTimeout(()=>{
              this.$router.push('/login');
            },1000)
            return false
          }
          that.lend_now = resData.lend_now;
          that.lend_history = resData.lend_histor;
          that.lend_count = resData.lend_count;
      }).catch(function(err){
          console.log(err)
      });
    },
    getLendList(){//周期
      let that = this;
      this.$ajax.get('/web/lendList',{}).then((res) => {
          let resData = res.data.data;
          that.cycleArr = resData;
          that.cycleArrDft = resData[0];
          that.cycleDays = resData[0].cycle_days;
          localStorage.setItem('fkjg',resData[0].company)
          that.dayArr = resData.map((item) => {
              return item.cycle_days
          });
          that.getDaySelect()
      }).catch(function(err){
          console.log(err)
      })
    },
    getDaySelect(){
      var weekdayArr = [];
      setTimeout(() => {
        weekdayArr = vm.dayArr;
        var mobileSelect1 = new MobileSelect({
            trigger: '.trigger1',
            title: vm.$t('wydb.jdzq'),
            wheels: [
                {data: weekdayArr}
            ],
            ensureBtnText: vm.$t('wydb.qd'),
            cancelBtnText: vm.$t('wydb.gb'),
            position:[0], //初始化定位 打开时默认选中的哪个 如果不填默认为0
            transitionEnd:function(indexArr, data){
                for(var i=0;i< vm.cycleArr.length;i++){
                    var p = vm.cycleArr[i];
                    if(p.cycle_days == data[0]){
                      vm.cycleArrDft = p;
                      vm.cycleDays = p.cycle_days;
                    }
                }
            },
            callback:function(indexArr, data){
                // console.log(data);
            }
        })
      },1500)
    },
    getMylist(){
      let params = {page: this.page};
      this.$ajax.get('/web/lendMylist',{params}).then((res) => {
        let resData = res.data.data;
        if(res.data.code == 1000){
          // this.$toast.center(res.data.message);
          setTimeout(()=>{
            this.$router.push('/login');
          },1000)
          return false
        }
        if(resData.length > 0){
            this.list = this.list.concat(resData);
            this.curDataLength = resData.length;
        }else{
            this.curDataLength = resData.length;
        }
        if(this.list.length > 0){
            this.isNoData = false;
        }else{
            this.isNoData = true;
        }
      }).catch(function(err){
          console.log(err)
      })
    },
    goHk(id,item){
      localStorage.setItem('hkCont',JSON.stringify(item));
      if(item.lend_type == "chain_address"){
        location.href = this.hkdz + "/index.html?id=" + id + "&from=h5" + "&url=" + this.projectTitle;
      }else{
        this.$router.push({ path: '/repayment2', query: { id: id } })
      }
    },
    keyMoney(){//输入数量规则
      var amount =  $('.number').val();
      amount = amount.replace(/[^\d.]/g, "");  //仅保留数字和"."
      amount = amount.replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      amount = amount.replace(".", "$#*").replace(/\./g,'').replace('$#*','.');//去除其他"."
      amount = amount.replace(/^(\d+)\.(\d\d\d\d).*$/, '$1.$2');;//限制只能输入两个小数
      if (amount.indexOf(".") < 0 && amount != "") { //首位是0的话去掉
          amount = parseFloat(amount)
      }
      $('.number').val(amount)
    },
    times2(timess){
      var date = new Date(timess * 1000);
      var Y = date.getFullYear() + '-';
      var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
      var D = date.getDate() < 10 ? '0' + date.getDate() : date.getDate();
      let h = date.getHours()<10?'0'+date.getHours():date.getHours();
      let m = date.getMinutes()<10?'0'+date.getMinutes():date.getMinutes();
      let s = date.getSeconds()<10?'0'+date.getSeconds():date.getSeconds();
      return Y + M + D + ' ' +h+':'+m+':'+s;
    },
  },
  beforeDestroy(){

  }
}
</script>
<style scoped>
    .head{
        position: fixed;
        top: 0;
        width: 100%;
        height: 1.6rem;
        padding: 0 .44rem;
        color: #000;
        line-height: 1.6rem;
        background: #fff;
        box-sizing: border-box;
        text-align: center;
    }
    .head .back{
        position: absolute;
        left: .4rem;
        top: 50%;
        width: .4rem;
        margin-top: -.4rem;
    }
    .head .title{
        font-size: .56rem;
    }
    .head .text{
        font-size: .48rem;
    }
    .cotainer{
        position: absolute;
        top: 1.6rem;
        bottom: 0;
        width: 100%;
        background: #f9f9f9;
        overflow-y: scroll;
    }
    .cotainer .cont{
      padding: .4rem;
      color: #fff;
    }
    .currency-head{
      padding: .48rem .6rem 1rem .55rem;
      background: #fff;
      box-shadow: 0 15px 84px 0 rgba(24, 11, 0, 0.18);
      border-radius: 0.28rem;
    }
    .currency-head .text{
      color: #000;
      font-size: .48rem;
    }
    .currency-head .money-box{
      padding: .6rem 0 .8rem;
      color: #000;
      font-size: .7rem;
    }
    .currency-head .money-box .dw{
      color: #1552f0;
    }
    .currency-head .tips{
      padding: .5rem 0 .35rem;
      color: #b0b0b0;
      font-size: .4rem;
    }
    .currency-head .input-box{
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 1.36rem;
      line-height: 1.36rem;
      border-radius: 0.22rem;
      border-radius: .2rem;
      border: solid .01rem #d5d5d5 !important;
    }
    .currency-head .input-box .input-money{
      flex: 1;
      padding: 0 .1rem 0 .6rem;
      color: #fff;
      font-size: .5rem;
    }
    .currency-head .input-box .btn-money{
      height: .96rem;
      padding: 0 .7rem;
      color: #fff;
      font-size: .44rem;
      line-height: .96rem;
      background: #000;
      border-radius: 0.22rem;
    }
    .currency-head .input-box .arrow{
      width: .4rem;
      margin-right: .4rem;
      cursor: pointer;
    }
    .currency-head .currency-info{
      display: flex;
      align-items: center;
    }
    .currency-head .currency-info .currency-li{
      width: 50%;
      background: transparent!important;
      text-align: center;
    }
    .currency-head .currency-info .t1{
      margin-top: .7rem;
      color: #696a6a;
      font-size: .4rem;
    }
    .currency-head .currency-info .t2{
      margin-top: .4rem;
      color: #000;
      font-size: .46rem;
    }
    .currency-head .currency-tips{
      padding: .8rem 0 1.2rem;
      color: #696a6a;
      font-size: .36rem;
    }
     .currency-head .btn-buy{
      height: 1.48rem;
      color: #fff;
      font-size: .5rem;
      line-height: 1.48rem;
      background: #000;
      border-radius: 0.72rem;
      text-align: center;
    }
    .records-tips{
      padding: 1.2rem 0 .8rem;
      color: #000;
      font-size: .58rem;
    }
    .records-li{
      margin-bottom: .2rem;
      padding: .35rem .45rem .55rem;
      box-shadow: 0rem 0.13rem 0.26rem 0rem
        rgba(24, 11, 0, 0.17);
      border-radius: 0.28rem;
    }
    .records-li .records-head{
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .records-li .records-head .order{
      color: #000;
      font-size: .42rem;
    }
    .records-li .records-head .status{
      color: #000;
      font-size: .4rem;
    }
    .records-li .times{
      padding: .3rem 0 .35rem;
      color: #8a8a8a;
      font-size: .32rem;
    }
    .records-li .date-box{
      display: flex;
      align-items: center;
    }
    .records-li .date-box .date{
      padding: 0 .4rem;
      height: 0.65rem;
      color: #fff;
      font-size: .36rem;
      line-height: .65rem;
      background: #6b708e;
      border-radius: 0.14rem;
    }
    .records-li .date-box .date.go{
      margin-left: .4rem;
      background: #ca3737;
      border: solid 0.01rem #fa0000
    }
    .records-li .item-li{
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding-top: .38rem;
    }
    .records-li .item-li .tl{
      color: #8a8a8a;
      font-size: .32rem;
    }
    .records-li .item-li .tr{
      color: #666;
      font-size: .32rem;
    }
</style>



// WEBPACK FOOTER //
// src/pages/currency.vue